import { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../../../../hooks/useAuth";
import TableLayout from "../../../../layouts/TableLayout/NewTableLayout";
import { useFetchAll } from "../../../../hooks/useFetchAll";
import {
  useGetPayoutsQuery,
  useUpdatePayoutMutation,
} from "../../../../redux/services/payouts/payoutsApi";
import { COLUMN_DEFINITIONS } from "./table.config";
import CreateModal from "../../../Payouts/CreateModal";

const DriverPayouts = ({ driver }) => {
  const { user } = useAuth();
  const params = useParams();
  const navigate = useNavigate();

  const [createModalOpen, setCreateModalOpen] = useState(false);

  // Use useFetchAll hook with employeeId filter (maps to driverId in backend)
  const {
    pagination: { pageIndex, pageSize, setPagination },
    queryResult: { data, isLoading, isFetching },
  } = useFetchAll({
    queryHook: useGetPayoutsQuery,
    defaultPageSize: 20,
    defaultFilters: useMemo(
      () => [{ id: "employeeId", value: params.id }],
      [params.id]
    ),
  });

  const [updatePayout] = useUpdatePayoutMutation();

  async function handleUpdate(e, setLoading) {
    try {
      const updateData = {
        id: e.row.original._id,
        data: e.data,
      };

      const res = await updatePayout(updateData).unwrap();

      toast(res.message, {
        type: res.status,
        toastId: "driver-payouts-update",
      });
    } catch (error) {
      toast.error("Failed to update payout", {
        toastId: "driver-payouts-update-error",
      });
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }

  function handleClick() {
    setCreateModalOpen(true);
  }

  function handleEdit(itemId) {
    navigate(`/payouts/${itemId}`);
  }

  return (
    <div className="xl:col-span-6 col-span-8 h-full min-h-0">
      <TableLayout
        id="driver-payouts"
        loading={isLoading || isFetching}
        columns={COLUMN_DEFINITIONS}
        data={data?.payouts}
        pagination={data}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPaginationChange={setPagination}
        handleEdit={handleEdit}
        onUpdate={handleUpdate}
        mainAction={{ onClick: handleClick, title: "Create Payout" }}
        title="Payouts"
        hideCheckbox
        meta={{
          updateData: handleUpdate,
        }}
      />
      <CreateModal
        modalOpen={createModalOpen}
        driver={driver}
        setModalOpen={setCreateModalOpen}
      />
    </div>
  );
};

export default DriverPayouts;
